<div class="itf-detail-container">
  <!-- Header with Payment Status -->
  <div class="detail-header">
    <div class="header-left">
      <h2>
        <i class="fas fa-user-tie"></i>
        {{ isNew ? 'Nuevo Registro ITF' : 'Detalle Registro ITF' }}
      </h2>
      <span *ngIf="!isNew && itfRecord.id" class="record-id">ID: #{{ itfRecord.id }}</span>
    </div>
    
    <div *ngIf="!isNew && !isEditMode" class="header-right">
      <div class="payment-status-container">
        <div class="payment-status" [ngClass]="paymentStatus.class">
          <i class="fas" [ngClass]="paymentStatus.icon"></i>
          <span>{{ paymentStatus.text }}</span>
        </div>
        <button 
          *ngIf="canRegisterPayment"
          (click)="openPaymentForm()" 
          class="btn-payment"
          [disabled]="showPaymentModal">
          <i class="fas fa-dollar-sign"></i>
          {{ itfRecord.matriculaVigente ? 'Renovar Matrícula' : 'Registrar Matrícula' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="alert alert-success">
    <i class="fas fa-check-circle"></i>
    {{ successMessage }}
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="alert alert-error">
    <i class="fas fa-exclamation-triangle"></i>
    {{ error }}
  </div>

  <!-- Main Form -->
  <div class="detail-content">
    <div class="top-sections-grid">
      
      <!-- COLUMN 1: Personal Information -->
      <section class="form-section">
        <h3>
          <i class="fas fa-user"></i>
          Información Personal
        </h3>
        
        <div class="form-group">
          <label>Nro. Libreta</label>
          <input 
            type="number" 
            [value]="itfRecord.nroLibreta"
            [disabled]="true"
            class="form-control">
          <small *ngIf="!itfRecord.nroLibreta" class="form-text">
            Sin vínculo a estudiante
          </small>
        </div>

        <div class="form-group" [class.has-error]="validationErrors['sexo']">
          <label>Sexo <span class="required">*</span></label>
          <!-- EDIT MODE -->
          <select 
            *ngIf="isEditMode"
            [(ngModel)]="editedRecord!.sexo"
            class="form-control">
            <option [value]="undefined">Seleccione...</option>
            <option value="M">Masculino</option>
            <option value="F">Femenino</option>
          </select>
          <!-- READ-ONLY MODE -->
          <div *ngIf="!isEditMode" class="readonly-value">
            {{ itfRecord.sexo === 'M' ? 'Masculino' : itfRecord.sexo === 'F' ? 'Femenino' : 'N/A' }}
          </div>
          <small *ngIf="validationErrors['sexo']" class="error-text">
            {{ validationErrors['sexo'] }}
          </small>
        </div>

        <div class="form-group" [class.has-error]="validationErrors['apellido']">
          <label>Apellido <span class="required">*</span></label>
          <!-- EDIT MODE -->
          <input 
            *ngIf="isEditMode"
            type="text" 
            [(ngModel)]="editedRecord!.apellido"
            class="form-control"
            style="text-transform: uppercase;">
          <!-- READ-ONLY MODE -->
          <div *ngIf="!isEditMode" class="readonly-value">
            {{ itfRecord.apellido }}
          </div>
          <small *ngIf="validationErrors['apellido']" class="error-text">
            {{ validationErrors['apellido'] }}
          </small>
        </div>

        <div class="form-group" [class.has-error]="validationErrors['nombre']">
          <label>Nombre <span class="required">*</span></label>
          <!-- EDIT MODE -->
          <input 
            *ngIf="isEditMode"
            type="text" 
            [(ngModel)]="editedRecord!.nombre"
            class="form-control"
            style="text-transform: uppercase;">
          <!-- READ-ONLY MODE -->
          <div *ngIf="!isEditMode" class="readonly-value">
            {{ itfRecord.nombre }}
          </div>
          <small *ngIf="validationErrors['nombre']" class="error-text">
            {{ validationErrors['nombre'] }}
          </small>
        </div>

        <div class="form-group">
          <label>Fecha de Nacimiento</label>
          <!-- EDIT MODE -->
          <input 
            *ngIf="isEditMode"
            type="date" 
            [(ngModel)]="editedRecord!.fcNacimiento"
            class="form-control">
          <!-- READ-ONLY MODE -->
          <div *ngIf="!isEditMode" class="readonly-value">
            {{ formatDate(itfRecord.fcNacimiento) }}
          </div>
        </div>

        <div class="form-group">
          <label>Nacionalidad</label>
          <!-- EDIT MODE -->
          <input 
            *ngIf="isEditMode"
            type="text" 
            [(ngModel)]="editedRecord!.nacionalidad"
            class="form-control"
            style="text-transform: uppercase;">
          <!-- READ-ONLY MODE -->
          <div *ngIf="!isEditMode" class="readonly-value">
            {{ itfRecord.nacionalidad || 'N/A' }}
          </div>
        </div>
      </section>

      <!-- COLUMN 2: Graduation + NGB + Payment (Stacked) -->
      <div class="middle-column-stack">
        
        <!-- Graduation Section -->
        <section class="form-section">
          <h3>
            <i class="fas fa-graduation-cap"></i>
            Graduación
          </h3>

          <!-- Read-only mode -->
          <div *ngIf="!isEditMode" class="form-group">
            <label>Grado Actual</label>
            <div class="readonly-value">
              {{ getGraduacionDisplay() }}
            </div>
          </div>

          <!-- Edit mode -->
          <div *ngIf="isEditMode">
            <div class="form-group" [class.has-error]="validationErrors['grado']">
              <label>Tipo de Grado <span class="required">*</span></label>
              
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    name="gradoTipo" 
                    value="GUP"
                    [(ngModel)]="gradoTipo"
                    (change)="onGradoTipoChange()">
                  <span>GUP (Cinturón de Color)</span>
                </label>
                
                <label class="radio-option">
                  <input 
                    type="radio" 
                    name="gradoTipo" 
                    value="DAN"
                    [(ngModel)]="gradoTipo"
                    (change)="onGradoTipoChange()">
                  <span>DAN (Cinturón Negro)</span>
                </label>
              </div>
              
              <small *ngIf="validationErrors['grado']" class="error-text">
                {{ validationErrors['grado'] }}
              </small>
            </div>

            <!-- GUP Selection -->
            <div *ngIf="gradoTipo === 'GUP'" class="form-group grado-select-group">
              <label>Número GUP <span class="required">*</span></label>
              <select 
                [(ngModel)]="editedRecord!.gup"
                (ngModelChange)="onGupChange()"
                class="form-control">
                <option [value]="null">Seleccione GUP...</option>
                <option *ngFor="let item of gupList" [value]="item.gup">
                  {{ item.graduacion.nombre }} - {{ item.gup }} GUP
                </option>
              </select>
            </div>

            <!-- DAN Selection + Certificate -->
            <div *ngIf="gradoTipo === 'DAN'" class="form-group grado-select-group">
              <label>Número DAN <span class="required">*</span></label>
              <select 
                [(ngModel)]="editedRecord!.dan"
                (ngModelChange)="onDanChange()"
                class="form-control">
                <option [value]="null">Seleccione DAN...</option>
                <option *ngFor="let item of danList" [value]="item.dan">
                  {{ item.graduacion.nombre }} - {{ item.dan }}
                </option>
              </select>

              <div class="form-group certificate-input" [class.has-error]="validationErrors['nuCertDan']">
                <label>N° Certificado DAN <span class="required">*</span></label>
                <input 
                  type="text" 
                  [(ngModel)]="editedRecord!.nuCertDan"
                  placeholder="AR-1-00000"
                  class="form-control"
                  [style.text-transform]="'uppercase'">
                <small class="form-text">
                  <i class="fas fa-info-circle"></i>
                  Formato: AR-[DAN]-[NÚMERO] (ej: AR-1-00123)
                </small>
                <small *ngIf="validationErrors['nuCertDan']" class="error-text">
                  {{ validationErrors['nuCertDan'] }}
                </small>
              </div>
            </div>
          </div>
        </section>

        <!-- NGB Section -->
        <section class="form-section">
          <h3>
            <i class="fas fa-building"></i>
            NGB
          </h3>
          
          <div class="form-group">
            <label>NGB</label>
            <!-- EDIT MODE -->
            <input 
              *ngIf="isEditMode"
              type="text" 
              [(ngModel)]="editedRecord!.ngb"
              class="form-control"
              style="text-transform: uppercase;">
            <!-- READ-ONLY MODE -->
            <div *ngIf="!isEditMode" class="readonly-value">
              {{ itfRecord.ngb || 'N/A' }}
            </div>
          </div>

          <div class="form-group">
            <label>Email NGB</label>
            <!-- EDIT MODE -->
            <input 
              *ngIf="isEditMode"
              type="email" 
              [(ngModel)]="editedRecord!.emailNgb"
              class="form-control">
            <!-- READ-ONLY MODE -->
            <div *ngIf="!isEditMode" class="readonly-value">
              {{ itfRecord.emailNgb || 'N/A' }}
            </div>
          </div>
        </section>

        <!-- Payment/Matrícula Section -->
        <section *ngIf="!isNew" class="form-section payment-section">
          <h3>
            <i class="fas fa-credit-card"></i>
            Matrícula
          </h3>
          
          <div class="payment-compact-grid">
            <!-- Left column -->
            <div class="payment-compact-left">
              <div class="compact-item">
                <label>Estado:</label>
                <span class="status-badge-compact" [ngClass]="paymentStatus.class">
                  {{ paymentStatus.text }}
                </span>
              </div>
              <div class="compact-item">
                <label>Último Pago:</label>
                <span>{{ formatDate(itfRecord.matriculaFcPago) }}</span>
              </div>
            </div>
            
            <!-- Right column -->
            <div class="payment-compact-right">
              <div class="compact-item">
                <label>Año Pagado:</label>
                <span class="highlight-value">{{ itfRecord.matriculaAnio || 'N/A' }}</span>
              </div>
              <div class="compact-item">
                <label>Monto:</label>
                <span class="highlight-value">{{ formatCurrency(itfRecord.matriculaMonto) }}</span>
              </div>
            </div>
          </div>

          <!-- Button to toggle payment history -->
          <div class="payment-history-toggle">
            <button (click)="togglePaymentHistory()" class="btn-link-compact">
              <i class="fas" [ngClass]="showPaymentHistory ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
              {{ showPaymentHistory ? 'Ocultar' : 'Ver' }} Historial
              <span class="badge" *ngIf="paymentHistory.length > 0">{{ paymentHistory.length }}</span>
            </button>
          </div>
        </section>

      </div>
      <!-- END OF COLUMN 2 -->

      <!-- COLUMN 3: Payment History (Toggle) -->
      <section *ngIf="!isNew && showPaymentHistory" class="form-section payment-history-section">
        <h3>
          <i class="fas fa-history"></i>
          Historial de Pagos
        </h3>

        <div class="payment-history">
          <table class="payment-table" *ngIf="paymentHistory.length > 0">
            <thead>
              <tr>
                <th>Año</th>
                <th>Fecha</th>
                <th>Monto</th>
                <th>Método</th>
                <th>Notas</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pago of paymentHistory">
                <td><strong>{{ pago.anio }}</strong></td>
                <td>{{ formatDate(pago.fechaPago) }}</td>
                <td>{{ formatCurrency(pago.monto) }}</td>
                <td>{{ pago.metodoPago || 'N/A' }}</td>
                <td>{{ pago.notas || '-' }}</td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="paymentHistory.length === 0" class="no-payments">
            <i class="fas fa-inbox"></i>
            <p>No hay pagos registrados</p>
          </div>
        </div>
      </section>
      <!-- END OF COLUMN 3 -->

    </div>
    <!-- END OF top-sections-grid -->
  </div>

  <!-- Action Buttons -->
  <div class="detail-actions">
    <button 
      *ngIf="!isEditMode && !isNew" 
      (click)="enableEdit()" 
      class="btn-edit">
      <i class="fas fa-edit"></i>
      Editar
    </button>

    <button 
      *ngIf="isEditMode" 
      (click)="cancelEditMode()" 
      class="btn-secondary"
      [disabled]="isSaving">
      <i class="fas fa-times"></i>
      Cancelar
    </button>

    <button 
      *ngIf="isEditMode" 
      (click)="saveRecord()" 
      class="btn-primary"
      [disabled]="isSaving">
      <i class="fas fa-save"></i>
      {{ isSaving ? 'Guardando...' : (isNew ? 'Crear Registro' : 'Guardar Cambios') }}
    </button>
  </div>
</div>

<!-- Payment Modal Component -->
<app-itf-payment-modal
  [itfRecord]="itfRecord"
  [show]="showPaymentModal"
  (close)="closePaymentForm()"
  (paymentRegistered)="onPaymentRegistered($event)">
</app-itf-payment-modal>